export default __webpack_public_path__ + "static/media/logo_md.995d7a8f.svg";